import React from 'react'
import "./Success.css"

const Success = () => {
  return (
    <div className="contact">
      <div className="contactlist">
        <div className="contact-list">
            <h1 className="contact-title" style={{ marginTop: "-3rem",marginBottom: "3rem",fontSize: "clamp(2.5rem, 5vw, 3rem)" }}>Contact Us</h1>
            <p style={{ color: "var(--text-secondary)", transition: "color 0.5s ease-in-out", fontSize: "clamp(0.8rem, 5vw, 1.2rem)" }}>Thank you for contacting us. We will get back to you shortly.</p>
            <a style={{ color: "var(--text-secondary)", transition: "color 0.5s ease-in-out", textDecoration: "none", fontSize: "clamp(0.8rem, 5vw, 1.2rem)" }} href="/">Go back to Home</a>
        </div>   
      </div>
    </div>
  )
}

export default Success